/* Copyright (c) 2017 Backpack Health LLC */

/* global API_BASE_URL, navigator, Connection */

import axios from 'axios';
import { authToken } from 'lib/storagePolyfill';
// import AppUtils from '../utilities/AppUtils';
// import { alertOfflineMode, isMobileOffline } from '../utilities/MobileUtil';
import ApiErrorModel from 'models/ApiErrorModel';

const CancelToken = axios.CancelToken;

const HOST = API_BASE_URL;
const API_VERSION = 'v1';
const UNAUTHORIZED_STATUS_CODE = 401;

function getBaseUrl() {
  return `${HOST}/api/${API_VERSION}`;
}

function logOutIfUnauthorized(err) {
  if (err.status === UNAUTHORIZED_STATUS_CODE) {
    // AppUtils.clearSavedData();
    // AppUtils.reloadApp();
  }
}

const appAxios = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'X-Backpack-Client-Context': 'groups',
    'X-Backpack-Client-Version': '6.0',
  }
});

const appAxiosAlt = axios.create({
  baseURL: getBaseUrl(),
  withCredentials: true,
  headers: {
    'X-Backpack-Client-Context': 'groups',
    'X-Backpack-Client-Version': '6.0',
  }
});
function axiosRequest(axiosInstance, restVerb, url, data, config) {
  switch (restVerb) {
    case 'post':
    case 'put':
    case 'patch':
      return axiosInstance[restVerb](url, data, config);
    default:
      return axiosInstance[restVerb](url, config);
  }
}

function authorizedApiRequestBlob(restVerb, url, errorHandler = logOutIfUnauthorized, extraHeaders) {
  const token = authToken.get();
  const headers = _.assign({}, {
    Authorization: `Bearer ${token}`,
  }, extraHeaders);

  const defaultConfig = _.assign({}, {
    responseType: 'blob',
    headers,
  });

  return (data, config) => (
    axiosRequest(appAxios, restVerb, url, data, _.assign({}, defaultConfig, config))
    .catch(err => Promise.reject(new ApiErrorModel(err.response)))
  );
}

function authorizedApiRequest(restVerb, url, errorHandler = logOutIfUnauthorized, extraHeaders) {
  const token = authToken.get();
  const headers = _.assign({}, {
    Authorization: `Bearer ${token}`,
  }, extraHeaders);

  return (data, config) => (
    axiosRequest(appAxios, restVerb, url, data, _.assign({}, { headers }, config))
    .catch(err => Promise.reject(new ApiErrorModel(err.response)))
  );
}

function authorizedApiRequestWithFullUrl(restVerb, url, errorHandler = logOutIfUnauthorized, extraHeaders) {
  const token = authToken.get();
  const headers = _.assign({}, {
    Authorization: `Bearer ${token}`,
  }, extraHeaders);

  return (data, config) => (
    axiosRequest(axios, restVerb, url, data, _.assign({}, { headers }, config))
    .catch(err => Promise.reject(new ApiErrorModel(err.response)))
  );
}

function apiRequest(restVerb, url, errorHandler = logOutIfUnauthorized, extraHeaders) {
  const headers = _.assign({}, extraHeaders);

  return (data, config) => (
    axiosRequest(appAxios, restVerb, url, data, _.assign({}, { headers }, config))
    .catch(err => Promise.reject(new ApiErrorModel(err.response)))
  );
}

function externalApi(restVerb, url, errorHandler = logOutIfUnauthorized, extraHeaders) {
  const headers = _.assign({}, extraHeaders);
  return (data, config) => (
    axiosRequest(axios, restVerb, url, data, _.assign({}, { headers }, config))
    .catch(err => Promise.reject(new ApiErrorModel(err.response)))
  );
}

function getCancelToken() {
  return CancelToken.source();
}

export {
  apiRequest,
  authorizedApiRequest,
  authorizedApiRequestBlob,
  authorizedApiRequestWithFullUrl,
  externalApi,
  getBaseUrl,
  getCancelToken,
};
